import { BaseClient } from '../client';
import { TConcessionaria } from './dealer.types';

interface setDealerProps {
  idConcessionaria: string;
  textoPadrao: string;
}

export const putDealerDefaultText = async ({ idConcessionaria, textoPadrao }: setDealerProps) => {
  // if (process.env.NODE_ENV === 'development') {
  //   return 'Alterado com sucesso';
  // }

  try {
    const response = await BaseClient.put<TConcessionaria>(
      `/Concessionarias/UpdateTextoPadraoConcessionaria`,
      { idConcessionaria, textoPadrao }
    ).then((response) => response.data);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const putDealerDefaultTextv2 = async (dto: DealerDefaultTextDTO) => {
  try {
    const response= await BaseClient.post("/user/set/texto/publicacao", dto);
    return response.data;
  } catch (error: any) {
    return error.response.data ?? {success: false, message: "Erro. Contate o Administrador."};
  }
}

export const fetchTextoPadrao = async (usuario_id: number, concessionaria_id:number) => {
  try {
    const response = await BaseClient.get("/user/get/texto/publicacao", {params: {id_concessionaria: concessionaria_id, id_usuario: usuario_id}});
    return response.data;
  } catch (error:any) {
    return error.response.data ?? {success: false, message:"Erro. Contate o Administrador"};
  }
};



export interface DealerDefaultTextDTO {
  id_concessionaria: number;
  id_usuario: number;
  texto_padrao: string;
}